import { http } from '@/plugins/http';
import { CONTENT_REPORTS_CONFIG } from '@/config';

/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export function sendSlackContentReports(_, { params, userInfo }) {
  const body = {
    username: userInfo,
    channel: CONTENT_REPORTS_CONFIG.channel,
    attachments: [{
      color: 'warning',
      mrkdwn_in: ['text'],
      text: `\n\n\`\`\`${JSON.stringify(params, null, '  ')}\`\`\``,
    }],
  };

  return http.post(CONTENT_REPORTS_CONFIG.url, JSON.stringify(body), {
    headers: { 'Content-Type': 'text/plain' },
    transformRequest: [(data, headers) => {
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      return data;
    }],
  });
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/store/actions.js